import addParamsToUrl from './addParamsToUrl';
import removeFromUrl from './removeFromUrl';

/*
 * Add the from url to a `from_url` parameter and tack it onto an href. That
 * way, if you navigate to that page, you can keep track of where you came from.
 * Currently used by the support form to send the problem url.
 */

const addFromUrl = (targetHref, currentHref) => {
  if (!currentHref || !targetHref) return targetHref;
  const currentUrl = removeFromUrl(String(currentHref));
  return addParamsToUrl(targetHref, { from_url: currentUrl });
};

export default addFromUrl;
